// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ChevronLeftBigIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15 19a1 1 0 01-.71-.29l-6-6a1 1 0 010-1.42l6-6a1 1 0 111.42 1.42L10.41 12l5.3 5.29a1 1 0 010 1.42A1 1 0 0115 19z" fill="currentColor"/></svg>'} />;

(ChevronLeftBigIcon as any).displayName = 'ChevronLeftBigIcon';

export default ChevronLeftBigIcon;
